import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { History, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const scoreColor = (s) => (s >= 70 ? 'text-green-600' : s >= 40 ? 'text-yellow-600' : 'text-red-600');

const overallScore = (scores) => {
  if (!scores || Object.keys(scores).length === 0) return 0;
  return Math.round(Object.values(scores).reduce((a, b) => a + b, 0) / Object.keys(scores).length);
};

const formatDate = (d) => {
  if (!d) return '';
  return new Date(d).toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
};

export const RecentCallsPeek = ({ teamView = false }) => {
  const [calls, setCalls] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/sessions/history?limit=3${teamView ? '&show_all=true' : ''}`);
        setCalls(res.data.sessions || []);
      } catch (e) {
        setCalls([]);
      }
    })();
  }, [teamView]);

  if (!calls || calls.length === 0) return null;

  return (
    <div className="bg-[#FAFAFA] border border-zinc-200 rounded-2xl p-6" data-testid="recent-calls-peek">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <History className="w-4 h-4 text-brand-primary" />
          <span className="text-xs font-bold uppercase tracking-widest text-zinc-500">{teamView ? 'Recent team calls' : 'Recent calls'}</span>
        </div>
        <Link
          to="/history"
          className="text-xs font-medium text-brand-primary hover:underline flex items-center gap-1"
          data-testid="recent-calls-view-all"
        >
          View all <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
      <div className="space-y-1">
        {calls.map((c) => {
          const score = overallScore(c.qualification_scores);
          return (
            <Link
              key={c.id}
              to={`/call/${c.id}`}
              className="flex items-center gap-3 rounded-xl px-3 py-2.5 -mx-1 transition-colors hover:bg-white hover:shadow-sm border border-transparent hover:border-zinc-200"
              data-testid={`recent-call-item-${c.id}`}
            >
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-zinc-800 truncate">
                  {c.prospect_name || 'Untitled call'}
                </p>
                <p className="text-xs text-zinc-500 truncate">
                  {c.company_name ? `${c.company_name} · ` : ''}{formatDate(c.created_at)}
                </p>
              </div>
              <span className={`text-sm font-mono font-bold shrink-0 ${scoreColor(score)}`}>{score}%</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
